module.exports = fox._r("images/promo/back-arr.png", __webpack_public_path__ + "_/_/_/common/frame/images/promo/back-arr.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/promo/back-arr.png
// module id = 397
// module chunks = 2